<template>
  <div>
    <b-tabs lazy>
      <b-tab title="Kpi:" disabled></b-tab>
      <b-tab title="Total" title-link-class="text-info">
        <b-row>
          <b-col cols="12" lg="6">
            <ulu-finance-kpi-types />
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-finance-kpi-types": () =>
      import(
        "@/components/dashboard/finance/finance_kpi/FinanceKpiTypes.vue"
      )
  }
};
</script>
